<template>
  <div class="sqqy">
    <div class="banner">
      <div class="img">
        <img src="../../assets/sqqy.png" />
        <!-- <img :src="this.$store.getters.banner[this.$route.path]" /> -->
      </div>
    </div>
    <div class="content">
      <div class="contentDiv">
        <div class="contentBox" v-html="content"></div>
        <!-- <div class="contentBox">
          <div class="item text">
            <p>
              “生前契约”是当事人生前就自己或亲人逝世后如何开展殡葬礼仪服务，而与殡葬服务公司订立的合约。它的概念源自英国的遗嘱信托，20世纪初引入美国，发展成为以消费者为导向的专业服务行业。
            </p>
            <p>
              二战后日本将美国成熟的“生前契约”制度导入日本并迅速普及，在欧美，生前契约已有60多年的历史，日本生前契约的普及率早已超过70%，在美国更高达90%以上。其服务内容包括：临终关怀、遗体接送、灵堂搭建、告别仪式及法律咨询等相关后续服务。
            </p>
            <img src="../../assets/sqqy1.png" alt="" />
            <p>
              2020年，东营嘉盛陵园有限责任公司正式将“生前契约”引入中国殡葬行业，将传统文化与现代服务理念相结合，旨在打造更加规范的行业准则及更完善的服务系统，
              引领中国现代殡葬行业的发展与变革。
            </p>
            <p>
              自服务推出以来，每年签订契约的人数都在以近倍的速度增长，上海、江苏、重庆、安徽、山东、江西、辽宁、河南、福建等地，越来越多的人开始接受并认同提前规划的概念，目前累计签订人数超万人。
            </p>
          </div>
          <div class="item lc">
            <p class="contitle marginb20">让生命的旅程流光溢彩</p>
            <div class="lcl">
              <div class="lclDiv acc">
                <div class="lcl-item">
                  <img src="../../assets/sqqy2.png" alt="" />
                  <p>咨询预约</p>
                </div>
                <div class="lcl-item">
                  <img src="../../assets/sqqy3.png" alt="" />
                  <p>工作人员</p>
                  <p>上门服务</p>
                </div>
                <div class="lcl-item">
                  <img src="../../assets/sqqy4.png" alt="" />
                  <p>选定</p>
                  <p>契约服务</p>
                </div>
                <div class="lcl-item">
                  <img src="../../assets/sqqy5.png" alt="" />
                  <p>购买成功</p>
                </div>
              </div>
            </div>
            <div class="lctc">
              <div class="lctc-item">
                <div class="lctc-con">
                  <div class="itemh">
                    <p>基础服务内容</p>
                  </div>
                  <div class="ptxt">
                    净身穿衣、大体接运、殡仪馆预约、追悼会、办理结账及火化
                  </div>
                </div>
                <div class="lctc-con">
                  <div class="itemh">
                    <p>温馨型6800</p>
                  </div>
                  <div class="ptxt">
                    基础服务、临终关怀、灵堂布置、出殡、取灰
                  </div>
                </div>
                <div class="lctc-con">
                  <div class="itemh">
                    <p>臻爱型12800</p>
                  </div>
                  <div class="ptxt">
                    基础服务、临终关怀、灵堂布置、出殡、取灰、头七或五七家祭指导服务
                  </div>
                </div>
                <div class="lctc-con">
                  <div class="itemh">
                    <p>尊荣型21800</p>
                  </div>
                  <div class="ptxt">
                    基础服务、临终关怀、灵堂布置、出殡、取灰、头七或五七家祭指导服务、祈福活动
                  </div>
                </div>
                <div class="lctc-con">
                  <div class="itemh">
                    <p>定制</p>
                  </div>
                  <div class="ptxt">
                    个性定制服务、具体咨询销售
                  </div>
                </div>
              </div>
            </div>
            <div class="lcts">
              <div class="moretxt">注：</div>
              <p>1、确定服务项目后双方将签定服务协议，确保客户权益。</p>
              <p>
                2、不同套餐服务项目和收费标准会有所不同，具体的服务项目和收费标准以洽谈为准。
              </p>
            </div>
          </div>
          <div class="item item-3">
            <p class="contitle marginb40">履约流程</p>
            <div class="itemBoxLine">
              <div class="itemBox">
                <div class="itemlist fl">
                  <img src="../../assets/n1.png" alt="" />
                  <div class="ptxt"><p>使用人身故</p></div>
                </div>
                <div class="itemlist fl">
                  <img src="../../assets/n2.png" alt="" />
                  <div class="ptxt">
                    <p>致电400-8801448白事天使到场</p>
                  </div>
                </div>
                <div class="itemlist fl">
                  <img src="../../assets/n3.png" alt="" />
                  <div class="ptxt">
                    <p>签署相关文件</p>
                  </div>
                </div>
                <div class="itemlist fl">
                  <img src="../../assets/n4.png" alt="" />
                  <div class="ptxt">
                    <p>提供殡仪服务</p>
                  </div>
                </div>
                <div class="itemlist fl">
                  <img src="../../assets/n5.png" alt="" />
                  <div class="ptxt">
                    <p>协助办理其他业务</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="contentTxt">{{ content }}</div> -->
        <div>
          <div class="bottomDiv bottomDivContent">
            <a href="tel:0546-75889977">24小时咨询热线 ｜ 0546-75889977</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from '../../common/http-service'
export default {
  name: 'shengqianqiyue',
  components: {},
  data() {
    return {
      content: '',
    }
  },
  created() {
    // this.getDate()
    var that = this
    this.$queryOne('OweArticle', { code: 'SQQY' }, ['content'], function(res) {
      that.content = res.data['content']
    })
  },
  methods: {
    // getDate() {
    //   let _data = {
    //     entity: 'OweArticle',
    //     fields: ['id', 'code', 'content'],
    //     code: 'SQQY',
    //   }
    //   let _this = this
    //   axios.post('/api/owearticle/queryOne', _data).then(res => {
    //     if (res.data.code == 1) {
    //       _this.content = res.data.data.content
    //     }
    //   })
    // },
  },
}
</script>

<style>
.sqqy .contentBox {
  /* overflow-x: hidden; */
}
.sqqy .contentBox .text {
  background: #faf9f7;
}
.sqqy .contentBox .item {
  padding: 0.67rem 0.4rem;
}
.sqqy .contentBox .text p {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.7rem;
  margin-bottom: 0.27rem;
}
.sqqy .contentBox .text img {
  widows: 9.2rem;
  height: 4.90667rem;
  margin: 0.8rem auto;
  width: 100%;
}
.sqqy .contitle {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
}
.sqqy .marginb20 {
  margin-bottom: 0.53rem;
}
.sqqy .contentBox .lcl {
  margin-bottom: 0.8rem;
}
.sqqy .acc {
  display: flex;
  justify-content: space-between;
}

.sqqy .contentBox .lcl-item {
  width: 1.54667rem;
  position: relative;
}
.sqqy .contentBox .lcl-item img {
  width: 1.04rem;
  height: 1.04rem;
  margin: 0 auto 0.27rem;
}
.sqqy .contentBox .lcl-item p {
  font-size: 0.32rem;
  color: #333;
  line-height: 0.45333rem;
  text-align: center;
}
.sqqy .contentBox .lcl-item:after {
  content: '';
  width: 0.64rem;
  height: 0.13333rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAKCAMAAAATmPcbAAAAAXNSR0IArs4c6QAAAOFQTFRFAAAA/wAA/39//6pV25Jt27Zt359g/79g46pV46px1Kpq6qpq3apm369g46pj16Fe6bFk4KNm4qdi5K1t5adq3apm3qVj4aVp4qhm3qpp4aZl3qhn3adn26Zn36do3qZn3qhm36hn4Kdo3qhm3qZm3qhm36Zo3qho3qdn4Klp3qdo3qdn4Kdn3qdo4Khp36hn36hn3adn3qdo36do3qdn3qhn36hn3qdn3qdn3qhn3qdm3qho3qdm3qhm36ho36hn3qZn36dn36do3qhm3qhn36hn3qdn3qdn3qdn36hn3qdnW3/QzAAAAEp0Uk5TAAECAwcHCAgJCQwMDxASExcZGhwdHh8iIycrLzQ5QEVGT1FVc3V2e3x8fYODkZKZnp+goKmqr7S6vMDK0dvf5+zs7O/y9fj6/PwVNupDAAAAg0lEQVQYGZXBhRHCQBRAwYcdFgju7u7uLr//gphMGjh20dPN8g+/fOZp9AVF5D1OoMsQy2sUhe335oX19aRgeTwomOx3CoablYLBYuqG1kxszx44XYDHDAHhTApIFvJArlwCivWaAyoNsT3aaImI5d430RMTkUvHQFdczs0A+pxVH7YfVOQT/VN+50sAAAAASUVORK5CYII=)
    no-repeat 50%/100% 100%;
  position: absolute;
  left: 1.6rem;
  top: 0.53rem;
}
.sqqy .contentBox .lctc {
  margin-bottom: 1.06667rem;
}
.sqqy .contentBox .lctc-con {
  width: 9.2rem;
  background: #fff;
  box-shadow: 0 0.027rem 0.05333rem 0 hsl(0deg 0% 72% / 20%);
  border-radius: 0.05333rem;
  border: 0.027rem solid #f8f8f8;
  overflow: hidden;
  margin-bottom: 0.8rem;
}
.sqqy .contentBox .lctc-con .itemh {
  width: 100%;
  height: 1.06667rem;
  background: #dea7675e;
  padding: 0.27rem;
}
.sqqy .contentBox .lctc-con .ptxt {
  padding: 0.27rem;
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.58667rem;
  background: #f6f6f6;
}
.sqqy .moretxt {
  font-size: 0.32rem;
  color: #dea767;
  line-height: 0.45333rem;
}
.sqqy .contentBox .lcts p {
  font-size: 0.32rem;
  color: #666;
  margin-top: 0.13333rem;
}
.sqqy .contentBox .item-3 {
  height: 13.6rem;
  background: url(../../assets/sqqy21.png) no-repeat 100%/70% 70%;
}
.sqqy .marginb40 {
  margin-bottom: 1.06667rem;
}
.sqqy .contentBox .itemlist {
  position: relative;
  margin-bottom: 1.44rem;
  display: flex;
}
.sqqy .contentBox .itemlist:first-child img {
  width: 0.53rem;
  margin-right: 0.58667rem;
}
.sqqy .contentBox .itemlist img {
  width: 0.64rem;
  height: 0.53rem;
  margin-right: 0.48rem;
}
.sqqy .contentBox .itemlist .ptxt {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  font-weight: 500;
}

.sqqy .bottomDivContent {
  height: 1.6rem;
  background: #fff;
  box-shadow: 0 -0.027rem 0.05333rem 0 hsl(0deg 0% 89% / 50%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 0.21333rem 0.4rem;
}
.sqqy .bottomDiv a {
  display: block;
  width: 9.2rem;
  height: 1.17333rem;
  background: url(../../assets/sqqy20.png) #dea767 no-repeat left 1.33rem center/.32rem 0.37333rem;
  border-radius: 0.58667rem;
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
  line-height: 1.17333rem;
  text-align: center;
  padding-left: 0.27rem;
}

.sqqy .banner {
  height: 3.73rem;
}
.sqqy .title {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
  margin-left: 0.5rem;
  margin-bottom: 0.53rem;
}
.sqqy .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.sqqy .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.sqqy .content {
  /* padding: 0.67rem 0.4rem; */
  background: #fff;
}
.sqqy .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap; */
  word-wrap: break-word;
}
.sqqy .contentTxt p {
  margin: 0.5rem 0;
}
</style>
